import { useAuthStore } from '@/store/useAuthStore'
import { ManagementSidebar } from './ManagementSidebar'

export function Sidebar() {
  const { canAccessManagement, canAccessPublic } = useAuthStore()

  // Render appropriate sidebar based on user role
  if (canAccessManagement()) {
    return <ManagementSidebar />
  }

  if (canAccessPublic()) {
    return <> </>
  }

  // Default fallback (shouldn't happen in normal flow)
  return null
}
